var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.header != 'client')?_c('NavigationBar'):_vm._e(),_c('router-view',{staticClass:"main"}),(_vm.$route.meta.header != 'client')?_c('Footer'):_vm._e(),_c('Loader'),_c('LogInModal'),_c('SendResetPasswordLinkModal'),_c('RegisterModal'),_c('ErrorModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }